import { getApiOrigin } from "./apiBase";

// Point Socket.IO at the same origin that serves the API. On platform
// hosts that resolves to VITE_BASE_URL's origin; on a tenant custom
// domain it resolves to the tenant's hostname (Cloudflare for SaaS
// proxies /socket.io/* through to our origin).
const SOCKET_ROOT = getApiOrigin();

export const SOCKET_CONFIG = {
  // 🟢 Point to ROOT, not API path
  URL: SOCKET_ROOT,

  OPTIONS: {
    transports: ["websocket"],
    autoConnect: false,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
  },
};
